<script>
import router from '@/router';

export default {
  name: 'auth',

  props: ['authToken', 'state'],

  render() { return null; },

  created() {
    this.$store.dispatch('authenticate', this.authToken).then(() => {
      router.push({ path: this.state });
    });
  },
};
</script>
